/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessengerSessionResponse } from '../models/MessengerSessionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class V2SupportService {
    /**
     * Issues the current user's secure Messenger session.
     * @returns MessengerSessionResponse Short-lived connection details with caching disabled.
     * @throws ApiError
     */
    public static getMessengerSession(): CancelablePromise<MessengerSessionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/support/messenger-session',
        });
    }
}
